module.exports = __webpack_public_path__ + "img/interaction_bac.3342e887.png";